export default __webpack_public_path__ + "static/media/3144.eef7db07.jpg";